import { createSlice } from "@reduxjs/toolkit";
import {
  createNoticeTemplateAction,
  getAllNoticeTemplatesAction,
  getNoticeTemplatesByOrganizationAction,
  getNoticeTemplateByIdAction,
  updateNoticeTemplateAction,
  deleteNoticeTemplateAction,
  searchAgreementsForNoticeTemplateAction,
  generateNoticesFromTemplateAction,
} from "../../actions/NoticeTemplatesAction/NoticeTemplatesAction";

const initialState = {
  noticeTemplates: [],
  noticeTemplate: null,
  generatedFile: null,
  searchResult: null,
  loading: false,
  error: null,
  success: false,
};

const noticeTemplateGeneraterSlice = createSlice({
  name: "noticeTemplateGenerater",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.noticeTemplate = null;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNoticeTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createNoticeTemplateAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.noticeTemplates.push(action.payload.data);
      })
      .addCase(createNoticeTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllNoticeTemplatesAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllNoticeTemplatesAction.fulfilled, (state, action) => {
        state.loading = false;
        state.noticeTemplates = action.payload.data;
      })
      .addCase(getAllNoticeTemplatesAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getNoticeTemplatesByOrganizationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getNoticeTemplatesByOrganizationAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.noticeTemplates = action.payload || [];
        },
      )
      .addCase(
        getNoticeTemplatesByOrganizationAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      )
      .addCase(getNoticeTemplateByIdAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNoticeTemplateByIdAction.fulfilled, (state, action) => {
        state.loading = false;
        state.noticeTemplate = action.payload.data;
      })
      .addCase(getNoticeTemplateByIdAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateNoticeTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateNoticeTemplateAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        const index = state.noticeTemplates.findIndex(
          (template) =>
            template.noticeTemplateGenerater_ID ===
            action.payload.data.noticeTemplateGenerater_ID,
        );
        if (index !== -1) {
          state.noticeTemplates[index] = action.payload.data;
        }
      })
      .addCase(updateNoticeTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteNoticeTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteNoticeTemplateAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.noticeTemplates = state.noticeTemplates.filter(
          (template) =>
            template.noticeTemplateGenerater_ID !== action.payload.id,
        );
      })
      .addCase(deleteNoticeTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(searchAgreementsForNoticeTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(
        searchAgreementsForNoticeTemplateAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.searchResult = action.payload;
        },
      )
      .addCase(searchAgreementsForNoticeTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateNoticesFromTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.generatedFile = null;
      })
      .addCase(generateNoticesFromTemplateAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.generatedFile = action.payload;
      })
      .addCase(generateNoticesFromTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetState } = noticeTemplateGeneraterSlice.actions;
export default noticeTemplateGeneraterSlice.reducer;
